import { PAGE_TYPE } from '../page-types'

/* ------- MICROFRONT - PANIER ------- */

export const cartRoutes = [
  {
    path: '/cart',
    name: 'cart',
    component: () => import('@b2ag/micro-front-cart/app'),
    props: () => ({
      microFrontName: 'cart',
      viewName: 'default',
    }),
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.CART,
    },
  },
]
